export default __webpack_public_path__ + "static/media/jee_mock_modal_web.023ffd3a.png";